export default __webpack_public_path__ + "static/media/logo-iso4457.45c1ec1b.svg";